import { useTranslation } from "@msuite/ui/localization";
import { cn } from "@msuite/ui/utils";
import { gridClasses } from "@/components/substitutions/substitution-plan-summary/shared";

export function SubstitutionPlanSummaryHeader() {
	const gc = gridClasses();
	const { t } = useTranslation();

	/** Render */
	return (
		<div className={cn(gc, "-mb-2 *:px-3 *:label")}>
			<div />
			<p>{t("substitutions.substitutions")}</p>
			<p>{t("contacts.contacts")}</p>
			<p>{t("notes.quick_note")}</p>
		</div>
	);
}
